module.exports = __webpack_public_path__ + "img/bess_chg_power.3793cba2.svg";